<div class="flex-direction-column gap-5">
  @if (label) {
  <div class="flex-direction-row align-center gap-5">
    <span
      class="label"
      [style.color]="colorLabel ?? ''"
      [style.font-size]="fontLabel"
      [style.font-weight]="fontWeight"
      >{{ label }}</span
    >
    @if (dica) {
    <img [matTooltip]="dica" src="./assets/icones/dica.svg" alt="Dica" />
    }
  </div>
  }

  <div
    class="custom-textarea-container"
    [ngClass]="classe"
    [style.width]="widthFormField"
    [style.background-color]="backgroundColor ?? 'white'"
    [style.border-color]="isInvalid ? '#f44336' : borderColor ?? 'transparent'"
    [style.min-height]="heightFormField"
  >
    @if (iconPrefix) {
    <mat-icon
      class="mat-icon-style prefix"
      [style.color]="iconColor ?? 'black'"
      >{{ iconPrefix }}</mat-icon
    >
    }

    <textarea
      #internalTextarea
      class="custom-textarea"
      [class.custom-textarea-sem-scroll]="crescerSemScroll"
      [(ngModel)]="value"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [attr.maxlength]="maxLengthFormFiles ? maxLengthFormFiles : null"
      [style.font-size]="font"
      (ngModelChange)="change()"
      (input)="autoResize(internalTextarea)"
      rows="1"
    ></textarea>

    @if (iconSuffix) {
    <mat-icon
      class="mat-icon-style suffix"
      [style.color]="iconColor ?? 'black'"
      >{{ iconSuffix }}</mat-icon
    >
    }
  </div>

  @if (showValidationErrors && isInvalid) {
  <div class="error-message">
    {{ getErrorMessage() }}
  </div>
  }
</div>
